<template>
  <div class="m2">
    <h5 class="text-center">{{ title }}</h5>
    <table class="table__border--gradient table--frontpage">
      <thead class="table__head--gradient">
        <th>Maand</th>
        <th>Trucks</th>
        <th>Trailers</th>
        <th>Vans</th>

      </thead>
      <tbody>
        <tr v-for="(item, key) in delivered_per_month_data" :key="key" class="table__row--color">
          <td>{{ item.Naam }}</td>
          <td class="table__data--right text-center">{{ item.Trucks }}</td>
          <td class="table__data--right text-center">{{ item.Trailers }}</td>
          <td class="table__data--right text-center">{{ item.Vans }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    delivered_per_month_data: Array,
    title: String,
  },
};
</script>
